<template>
    <!-- Payment Options Section -->
    <div class="row center-content" v-if="applicationForm.bill_status == 'assigned' && !isPayButtonLoading">
        <div class="checkout-page" style="width: 100%; max-width: 900px; margin: 0 auto;">
            <div class="checkout-form theme-form">
                <div class="row center-content">
                    <div class="col-lg-12 col-sm-12 col-xs-12">
                        <div class="theme-card check-out ng-star-inserted">
                            <div class="payment-options-container">
                                <h5
                                    style="text-align: center; margin-bottom: 25px; color: #2c3e50; font-weight: 600; letter-spacing: 0.5px;">
                                    Choose Your Payment Method
                                </h5>

                                <!-- Payment Cards Grid -->
                                <div class="row"
                                    style="display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">

                                    <!-- bKash Card -->
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                        <div class="payment-card" @click="startBkashCheckoutService"
                                            style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                            <div class="payment-card-logo" style="margin-bottom: 10px;">
                                                <img alt="bKash"
                                                    style="height: 60px; max-width: 100%; object-fit: contain;"
                                                    class="img-fluid" src="../../theme-assets/images/logo/bkash.png">
                                            </div>
                                            <div class="payment-card-title"
                                                style="font-size: 14px; font-weight: 600; color: #E2136E; margin-top: 8px;">
                                                bKash
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Rocket Card -->
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                        <div class="payment-card" @click="startDbblRocketPayment"
                                            style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                            <div class="payment-card-logo" style="margin-bottom: 10px;">
                                                <img alt="DBBL Rocket"
                                                    style="height: 60px; max-width: 100%; object-fit: contain;"
                                                    class="img-fluid"
                                                    src="../../theme-assets/images/logo/rocket.png">
                                            </div>
                                            <div class="payment-card-title"
                                                style="font-size: 14px; font-weight: 600; color: #8B3A8B; margin-top: 8px;">
                                                Rocket
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Visa Card -->
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                        <div class="payment-card" @click="startDbblVisaPayment"
                                            style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                            <div class="payment-card-logo" style="margin-bottom: 10px;">
                                                <img alt="Visa Card"
                                                    style="height: 60px; max-width: 100%; object-fit: contain;"
                                                    class="img-fluid" src="../../theme-assets/images/logo/visa-sq.png">
                                            </div>
                                            <div class="payment-card-title"
                                                style="font-size: 14px; font-weight: 600; color: #1434CB; margin-top: 8px;">
                                                Visa Card
                                            </div>
                                        </div>
                                    </div>

                                    <!-- MasterCard -->
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                        <div class="payment-card" @click="startDbblMasterCardPayment"
                                            style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                            <div class="payment-card-logo" style="margin-bottom: 10px;">
                                                <img alt="MasterCard"
                                                    style="height: 60px; max-width: 100%; object-fit: contain;"
                                                    class="img-fluid"
                                                    src="../../theme-assets/images/logo/mastercard-sq.png">
                                            </div>
                                            <div class="payment-card-title"
                                                style="font-size: 14px; font-weight: 600; color: #EB001B; margin-top: 8px;">
                                                MasterCard
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <p
                                    style="text-align: center; margin-top: 20px; color: #6c757d; font-size: 13px; line-height: 1.5;">
                                    Click on your preferred payment method to proceed securely
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else-if="applicationForm.bill_status == 'assigned' && isPayButtonLoading"
        style="max-width: 100%;margin:auto;">
        <button style="margin-top:10px" :class="isPayButtonLoadingClass" type="button" blockx disabled>
            <i class="fa fa-spinner fa-spin"></i> Connecting to the payment gateway ...
        </button>
    </div>
</template>
<script>
export default {
    name: "GCEPaymentComponent",
    props: {
        applicationForm: {
            type: Object,
            required: true
        },
        isPayButtonLoading: {
            type: Boolean,
            required: true
        },
        isPayButtonLoadingClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        isPayButtonLoadingClass() {
            return this.isPayButtonLoading ? 'btn btn-primary btn-block mt-2' : 'btn btn-primary btn-block mt-2';
        }
    },
    methods: {
        startBkashCheckoutService() {
            this.$emit('start-bkash-checkout-service');
        },
        startDbblRocketPayment() {
            this.$emit('start-dbbl-rocket-payment');
        },
        startDbblVisaPayment() {
            this.$emit('start-dbbl-visa-payment');
        },
        startDbblMasterCardPayment() {
            this.$emit('start-dbbl-mastercard-payment');
        }
    }
};
</script>
<style scoped></style>
